import { FC, useCallback, useMemo } from 'react'
import * as Icons from '@ant-design/icons'
import { Select } from 'antd'

import { FormItem } from 'admin/lib/Forms'
import { useApiQuery } from 'admin/lib/Api'
import { Waste as fields } from 'admin/lib/Records'

export interface KnownContainerTypePresetSelectProps {
  onChange: (a: string) => void
  namePrefix: string
  index: number
  defaultValue: string | null
  disabled?: boolean
  hidden?: boolean
}

export const KnownContainerTypePresetSelect: FC<
  KnownContainerTypePresetSelectProps
> = ({
  onChange,
  namePrefix,
  index,
  defaultValue,
  disabled = false,
  hidden = false
}) => {
  const fetchOptions = useApiQuery(
    useCallback(api => api.getWasteContainerTypes(), [])
  )

  const handleSelect = useCallback(
    value => {
      if (onChange) {
        onChange(value)
      }
    },
    [onChange]
  )

  const handleClear = useCallback(() => {
    if (onChange) {
      onChange('')
    }
  }, [onChange])

  const options: OptionType[] = useMemo(() => {
    if (
      fetchOptions.loaded &&
      fetchOptions.data &&
      Array.isArray(fetchOptions.data)
    ) {
      return (fetchOptions.data as string[]).map(option => {
        return { value: option, label: option }
      })
    }
    return []
  }, [fetchOptions.data, fetchOptions.loaded])

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  return (
    <FormItem
      label={fields.lineItems.knownContainerType.label}
      name={namePrefix + fields.lineItems.knownContainerType.path}
      id={`wasteLineItemKnownContainerType_${index}`}
      defaultValue={defaultValue}
      disabled={disabled}
      hidden={hidden}
    >
      <Select
        showSearch
        loading={!fetchOptions.loaded}
        placeholder="Select a Container type to apply"
        optionFilterProp="children"
        filterOption={filterOption}
        options={options}
        onSelect={handleSelect}
        suffixIcon={<Icons.SearchOutlined />}
        style={{ width: '100%' }}
        allowClear={true}
        onClear={handleClear}
      />
    </FormItem>
  )
}

type OptionType = {
  value: string
  label: string
}
